<template>
  <el-dialog
    :title="!dataForm.isE ? '冻结供应商' : '解冻供应商'"
    :close-on-click-modal="false"
    class="abow_dialog"
    width="55%"
    :visible.sync="visible">
    <el-form  size="mini" :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="110px" class="user-info-dialog-form">
      <el-tabs style="min-height: 50vh;">
        <el-tab-pane class="tab_style" :key="1" label="基础信息" >
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item label="供应商代码" prop="venderCode">
                <el-input v-model="dataForm.venderCode"  placeholder="供应商代码" :disabled= true></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item label="供应商名称" prop="venderName">
                <el-input v-model="dataForm.venderName" placeholder="供应商名称" :disabled=true></el-input>
              </el-form-item>
            </el-col>
          </el-row>
<!--          <el-row :gutter="40">-->
<!--            <el-col v-if="this.dataForm.isE === 0" :span="12">-->
<!--              <el-form-item label="冻结日期" prop="freezingDate">-->
<!--                <el-date-picker-->
<!--                  v-model="dataForm.freezingDate"-->
<!--                  type="date"-->
<!--                  value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                  format="yyyy-MM-dd"-->
<!--                  placeholder="选择日期">-->
<!--                </el-date-picker>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col v-if="this.dataForm.isE === 1" :span="12">-->
<!--              <el-form-item label="解冻日期" prop="freezingDateEnd">-->
<!--                <el-date-picker-->
<!--                  v-model="dataForm.freezingDateEnd"-->
<!--                  type="date"-->
<!--                  value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                  format="yyyy-MM-dd"-->
<!--                  placeholder="选择日期">-->
<!--                </el-date-picker>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            &lt;!&ndash;<el-col :span="12">-->
<!--              <el-form-item label="审批单号" prop="applyNumber">-->
<!--                <el-input v-model="dataForm.applyNumber" :disabled=true></el-input>-->
<!--              </el-form-item>-->
<!--            </el-col>&ndash;&gt;-->
<!--          </el-row>-->

          <el-row :gutter="40">
              <el-form-item label="备注" prop="remarks">
              <el-col :span="12">
            <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="dataForm.remarks">
                </el-input>
             </el-col>
             </el-form-item>
          </el-row>
        </el-tab-pane>
        <el-tab-pane class="tab_style" :key="2" label="附件文件">
          <!--<el-row :gutter="40">
            <el-form-item label="相关附件" prop="name">
              <el-col :span="12">
                <el-button type="text" @click="fileView">相关附件</el-button>
              </el-col>
            </el-form-item>
          </el-row>-->
          <FileUpDown ref="FileUpDown" :fileSubType="FILE_SUB_TYPE" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FileUpDown>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <el-row>
      <el-col style="text-align: right;">
        <el-button size="mini" @click="visible = false">取消</el-button>
        <el-button :loading="dataFormSubmitLoading" type="primary" size="mini" @click="dataFormSubmit()">提交申请</el-button>
      </el-col>
    </el-row>

    <el-dialog
          title="提示"
          :visible.sync="fileDialogVisible"
          width="60%"
          :modal="false"
          >

          <!-- 上传下载 查看 需求文档 -->
          <FileUpDown ref="FileUpDown" :fileSubType="FILE_SUB_TYPE" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FileUpDown>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="fileDialogVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
  </el-dialog>
</template>

<script>
  import {selectSupplierById,frozenThaw} from '@/controller/supplier'
  import FileUpDown from "@/views/common/file-up-down"

  export default {
    data () {

      return {
        fileDialogVisible:false,
        dataFormSubmitLoading:false,
        visible: false,
        FILE_BIZ_TYPE:9,
        FILE_SUB_TYPE:0,
        initValue: {
        },
        // 主要用于存储和页面显示相关的数据以及状态
        view: {
        },
        // 用于存储form 中的数据
        dataForm: {
          id: 0,
          isE:'',
          venderCode: '',
          venderName : '',
          remarks:'',
          // freezingDate : '',
          // freezingDateEnd : '',
          ftWorkFlowId:'',
          applyStatus:'',
          applyNumber:'',
          subcompanyId:''
        },
        dataRule: {
        //   venderCode: [
        //     { required: true, message: '供应商代码不可为空', trigger: 'change' }
        //   ],
        //   venderName: [
        //     { required: true, message: '供应商名称不可为空', trigger: 'change' }
        //   ],
        // freezingDate: [
        //     { required: true, message: '不可为空', trigger: 'change' }
        //   ],
        },
        files:[]
      }
    },

    components: {
        FileUpDown //上传附件
    },

    methods: {



      init (row) {
        debugger
        this.visible = true
        this.dataForm.id = row.id || 0
        this.dataForm.isE = row.isE
        this.dataForm.ftWorkFlowId = row.ftWorkFlowId
        this.dataForm.applyStatus = row.applyStatus
        this.dataForm.applyNumber = row.applyNumber
        this.dataForm.subcompanyId=row.subcompanyId
        if(row.isE === 0){
            this.FILE_SUB_TYPE = 3
        }
        if(row.isE === 1){
            this.FILE_SUB_TYPE = 4
        }

        this.$nextTick(() => {
             this.$refs.FileUpDown.init("edit");
            this.$refs['dataForm'].resetFields()
            // this.dataForm.tenantId = sessionStorage.getItem('tenantId')
            // this.dataForm.tenantName = sessionStorage.getItem('tenantName')
            //this.dataForm.userTypeList = []

        selectSupplierById(
                  {id : this.dataForm.id}
           ).then(data => {
             if (data && data.code === '00') {
               this.dataForm = {...this.dataForm, ...data.body}
             }
           })

        })
      },


      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
    //   handleExceed(files, fileList) {
    //     this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    //   },
    //   beforeRemove(file, fileList) {
    //     return this.$confirm('确定移除 ${ file.name }？');
    //   },

      // 表单提交
      dataFormSubmit () {


        // if(!sessionStorage.getItem('venderCode')){
        //     this.$message({message: '供应商代码不可为空22',type: 'error'})
        //     return
        // }
        // if(!sessionStorage.getItem('enterpriseName')){
        //     this.$message({message: '供应商名称不可为空',type: 'error'})
        //     return
        // }
        // if(this.files.length === 0){
        //     this.$message({message: '附件不可为空，请上传相关附件',type: 'error'})
        //     return
        // }

        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
              var freezingThawFlg;
              if(this.dataForm.isE === 0){
                  freezingThawFlg = true;
              }
              if(this.dataForm.isE === 1){
                  freezingThawFlg = false;
              }

            let params = {
              'supplierId': this.dataForm.id || undefined,
            //   'venderCode': this.dataForm.venderCode,
            //   'venderName': this.dataForm.venderName,
              'frozenReason': this.dataForm.remarks,
              'freezingThawFlg': freezingThawFlg,
              // 'freezingDate': this.dataForm.freezingDate,
              // 'freezingDateEnd': this.dataForm.freezingDateEnd,
              'ftWorkFlowId': this.dataForm.ftWorkFlowId,
              'applyStatus':this.dataForm.applyStatus,
              'subcompanyId':this.dataForm.subcompanyId
            }
            this.dataFormSubmitLoading = true
            frozenThaw(params
              ).then(data => {
                if (data && data.code === '00') {
                  this.$message({
                    message: '提交成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.visible = false
                      //data.body
                      //this.dataForm.applyId = data.body.id
                      //this.dataForm.applyNumber = data.body.applyformNum
                      this.$emit('refreshDataList')
                      this.dataFormSubmitLoading = false
                    }
                  })
                } else {
                  this.dataFormSubmitLoading = false
                  this.$message.error(data.msg)
                }
              }).catch((e)=>{
                  this.dataFormSubmitLoading = false
              })
            
          }
        })
      },
      
      // 文件列表
      fileView(){
        this.fileDialogVisible = true
        this.$nextTick(()=>{
            this.$refs.FileUpDown.init(this.dataForm.id, this.FILE_BIZ_TYPE, null)
        })
      },

      


    }
  }
</script>
<style lang="scss">
  .el-dialog__body{
    .user-info-dialog-form{
      width: 95%;
      .el-select{
        width: 222px;
      }
    }
  }
</style>